var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14737 8.22831C4.34549 8.22831 2.88477 6.7676 2.88477 4.96572C2.88477 3.16384 4.34549 1.70312 6.14737 1.70312C7.94925 1.70312 9.40996 3.16384 9.40996 4.96572C9.40996 6.7676 7.94925 8.22831 6.14737 8.22831Z",
    fill: "#FBA12B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98147 9.90845C6.70902 9.87627 6.4304 9.8596 6.14703 9.8596C3.0002 9.8596 0.4375 11.915 0.4375 14.4476C0.4375 14.6189 0.575685 14.7535 0.751556 14.7535H9.3879C7.67483 13.3959 7.08815 11.395 6.98147 9.90845Z",
    fill: "#FBA12B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84149 8.67851L11.8128 7.45503C11.9539 7.39641 12.1124 7.39641 12.2535 7.45503L15.2248 8.67851C15.4501 8.77282 15.5987 8.99712 15.5987 9.24691C15.5987 10.8604 14.9574 13.5495 12.2634 14.7067C12.1173 14.7704 11.9514 14.7704 11.8054 14.7067C9.10891 13.5495 8.46761 10.8604 8.46761 9.24691C8.46761 8.99712 8.61617 8.77282 8.84149 8.67851Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.0c080876029fb197bf81e83063afc6c6.svg";
export { ForwardRef as ReactComponent };